<div class="error-container" [attr.data-testid]="testId">
  <ng-content></ng-content>
</div>
